import { Injectable } from "@angular/core";

@Injectable()
export class BreakLengthValidator {
    public validate(fieldValue: string | null): string | null {
        if (!fieldValue) {
            return null;
        }

        const parts = fieldValue.split(":");
        if (parts.length !== 3) {
            return "Invalid value. Must be in format mmm:ss:ff";
        }

        const minutes = parts[0];
        const seconds = parts[1];
        const frames = parts[2];

        if (!minutes.match(/^[0-9]{1,3}$/)) {
            return "Invalid minutes. Must be a number between 0-999.";
        }

        if (!seconds.match(/^[0-5][0-9]$/)) {
            return "Invalid seconds. Must be a number between 00-59.";
        }

        if (!frames.match(/^[0-9]{2}$/)) {
            return "Invalid frames. Must be a number between 00-99.";
        }

        return null;
    }
}
